module.exports = __webpack_public_path__ + "img/logo.d5e8428c.png";